/* eslint-disable react/no-unknown-property */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ClientStatusToggle from "./clients/client_status_toggle";
import RemoveClientBtn from "./clients/remove_client_btn";
import ClientModal from "./import-export-clients/client_modal";

const ShowDuplicatesModal = ({ similar_clients }) => {
  const [isOpen, setIsOpen] = useState(true);

  const [similarClients, setSimilarClients] = useState(
    Array.isArray(similar_clients) ? similar_clients : []
  );
  useEffect(() => {
    if (similarClients.length === 0) {
      setIsOpen(false);
    }
  }, [similarClients]);

  if (!similar_clients || !Array.isArray(similar_clients) || similar_clients.length === 0)
    return <></>;
  if (!isOpen) return <></>;
  // const byPassDuplicateCreation = () => {
  //   setIsOpen(false);
  //   const submitBtn = document.querySelector(".client-action-edit-active input[type='submit']");
  //   if (!submitBtn) {
  //     alert("Unknown error, please click Save manually");
  //   } else {
  //     submitBtn.click();
  //   }
  // };

  // TODO test this with new inactive/is deceased logic
  return (
    <ClientModal
      closeTestId="client-edit-create-duplicate-modal-close-icon"
      description="One or more existing client records match the identifying details you entered. Review them before continuing."
      eyebrow="Possible match"
      footer={
        <button
          className="button ccw-button ccw-button--primary"
          explorator_test_id="client-duplicate-close-btn"
          onClick={() => setIsOpen(false)}
          type="button"
        >
          Return to client form
        </button>
      }
      modifier="duplicates"
      onClose={() => setIsOpen(false)}
      title="Duplicate Clients"
    >
      <div className="ccw-notice ccw-client-duplicates-notice" role="status">
        <i aria-hidden="true" className="fas fa-info-circle" />
        <p>
          Open an existing record to confirm the details. Status and ignore actions affect the
          existing client record immediately.
        </p>
      </div>

      <div className="client-body client-body-in-modal ccw-client-modal__records">
        <div className="ccw-client-modal__records-heading">
          <h2>Matching records</h2>
          <span>
            {similarClients.length} {similarClients.length === 1 ? "match" : "matches"}
          </span>
        </div>
        <table className="ccw-client-modal__table ccw-client-modal__table--duplicates">
          <caption className="is-sr-only">Existing client records that may be duplicates</caption>
          <thead>
            <tr className="clients-title">
              <th>REG#</th>
              <th>Client name</th>
              <th>Location</th>
              <th>Date of birth</th>
              <th>Health card</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="client-box">
            {similarClients &&
              similarClients.map((newClient) => (
                <React.Fragment key={newClient.id}>
                  <tr
                    explorator_test_id={`client-duplicated-row-${newClient.id}`}
                    className="card-container__top clients-page-import-export-modal-client-container"
                  >
                    <td data-label="REG#">{newClient.id}</td>
                    <td data-label="Client name">
                      <div className="ccw-client-modal__cell-content">
                        <strong>{`${newClient.first_name} ${newClient.last_name}`}</strong>
                        <span
                          className={`ccw-status ccw-client-modal__status ccw-client-modal__status--${
                            newClient.inactive ? "inactive" : "active"
                          }`}
                        >
                          {newClient.inactive ? "Inactive" : "Active"}
                        </span>
                      </div>
                    </td>
                    <td data-label="Location">{newClient.location || "—"}</td>
                    <td data-label="Date of birth">{newClient.dob || "—"}</td>
                    <td data-label="Health card">
                      <div className="ccw-client-modal__cell-content">
                        <span>{newClient.healthcard_number || "Not provided"}</span>
                        {(newClient.healthcard_version_code || newClient.healthcard_expiry) && (
                          <small>
                            {newClient.healthcard_version_code &&
                              `Version ${newClient.healthcard_version_code}`}
                            {newClient.healthcard_version_code &&
                              newClient.healthcard_expiry &&
                              " · "}
                            {newClient.healthcard_expiry &&
                              `Expires ${newClient.healthcard_expiry}`}
                          </small>
                        )}
                      </div>
                    </td>
                    <td data-label="Actions">
                      <div className="ccw-client-modal__row-actions">
                        <a
                          className="ccw-button client-duplicated-row-edit-link"
                          explorator_test_id={`client-duplicated-row-edit-link-${newClient.id}`}
                          href={newClient.edit_url}
                        >
                          Open record
                        </a>
                        <ClientStatusToggle
                          clientId={newClient.id}
                          isActive={!newClient.inactive}
                          setClientInActive={(inActive) => {
                            setSimilarClients(
                              similarClients.map((client) =>
                                client.id === newClient.id
                                  ? { ...client, inactive: inActive }
                                  : client
                              )
                            );
                          }}
                        />
                        <RemoveClientBtn
                          clientId={newClient.id}
                          removeClient={() => {
                            setSimilarClients(
                              similarClients.filter((client) => client.id !== newClient.id)
                            );
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        </table>
      </div>
    </ClientModal>
  );
};

ShowDuplicatesModal.propTypes = {
  similar_clients: PropTypes.array,
  action: PropTypes.string
};

export default ShowDuplicatesModal;
